"use strict";

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.reduce.js");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable @typescript-eslint/no-explicit-any */

var styled_components_1 = require("styled-components");

var config = {
  sizing: 'px',
  columns: 12,
  gap: {
    xs: 8,
    sm: 8,
    md: 16,
    lg: 16,
    xl: 16
  },
  breakpoints: {
    xs: 375,
    sm: 414,
    md: 768,
    lg: 1024,
    xl: 1440
  }
};

exports.isString = function (str) {
  return typeof str === 'string' || str instanceof String;
};

exports.isNumber = function (num) {
  return typeof num === 'number' || Number.isInteger(num);
};

exports.isBoolean = function (bool) {
  return typeof bool === 'boolean';
};

var sizeMaps = function sizeMaps(size) {
  return {
    xsmall: 'xs',
    small: 'sm',
    medium: 'md',
    large: 'lg',
    xlarge: 'xl'
  }[size] || size;
};

var mediaQuery = function mediaQuery(breakpoints) {
  if (breakpoints === void 0) {
    breakpoints = config.breakpoints;
  }

  return Object.keys(breakpoints).reduce(function (acc, label) {
    acc[sizeMaps(label)] = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media screen and (min-width: ", "px) {\n        ", ";\n      }\n    "], ["\n      @media screen and (min-width: ", "px) {\n        ", ";\n      }\n    "])), breakpoints[label || sizeMaps(label)], styled_components_1.css.apply(void 0, args));
    };

    return acc;
  }, {});
};

var propertyMaps = function propertyMaps(name) {
  return {
    flexDirection: 'flex-direction',
    flexWrap: 'flex-wrap',
    justifyContent: 'justify-content',
    alignItems: 'align-items',
    alignContent: 'align-content',
    display: 'display'
  }[name];
};

var getBreakpoints = function getBreakpoints(args) {
  return args.theme && args.theme.breakpoint || args.theme && args.theme.breakpoints && args.theme.breakpoints.values || config.breakpoints;
};

exports.makeStyledMediaQuery = function (propertyName, args) {
  var propertyValue = args[propertyName];
  if (!propertyValue) return null;
  var breakpoints = getBreakpoints(args);
  var mq = mediaQuery(breakpoints);
  var cssProperty = propertyMaps(propertyName);
  var isPropertyValueAString = exports.isString(propertyValue);
  if (isPropertyValueAString) return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ":", ";\n    "], ["\n      ", ":", ";\n    "])), cssProperty, propertyValue);
  return Object.entries(propertyValue).map(function (_a) {
    var size = _a[0],
        value = _a[1];
    return mq[sizeMaps(size)](templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), cssProperty, value);
  });
};

exports.makeStyledMediaQueryGap = function (type, args, negative) {
  var propertyValue = args.gutter || args.gap || args.theme && args.theme.grid && args.theme.grid.gap;
  if (!propertyValue) return null;
  var breakpoints = getBreakpoints(args);
  var mq = mediaQuery(breakpoints);
  var isPropertyValueAString = exports.isString(propertyValue);
  if (isPropertyValueAString) return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", "-left: ", ";\n      ", "-right: ", ";\n    "], ["\n      ", "-left: ", ";\n      ", "-right: ", ";\n    "])), type, propertyValue, type, propertyValue);
  var isPropertyValueANumber = exports.isNumber(propertyValue);
  if (isPropertyValueANumber) return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", "-left: ", "px;\n      ", "-right: ", "px;\n    "], ["\n      ", "-left: ", "px;\n      ", "-right: ", "px;\n    "])), type, propertyValue / 2 * (negative ? -1 : 1), type, propertyValue / 2 * (negative ? -1 : 1));
  return Object.entries(propertyValue).map(function (_a) {
    var size = _a[0],
        value = _a[1];
    return mq[sizeMaps(size)](templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "-left: ", "px; ", "-right: ", "px;"], ["", "-left: ", "px; ", "-right: ", "px;"])), type, value / 2 * (negative ? -1 : 1), type, value / 2 * (negative ? -1 : 1));
  });
};

exports.makeStyledMediaQueryFlexWidth = function (args) {
  var breakpoints = args.width || getBreakpoints(args);
  var columns = args.columns || args.theme && args.theme.grid && args.theme.grid.columns || config.columns || 12;
  var mq = mediaQuery(breakpoints);
  return Object.keys(breakpoints).map(function (size) {
    var value = args.width && args.width[sizeMaps(size)] || args[sizeMaps(size)];
    var isValueANumber = exports.isNumber(value);
    var isValueAString = exports.isString(value);
    var isValueABoolean = exports.isBoolean(value);
    if (!value && !isValueABoolean) return null;
    if (isValueANumber) return mq[sizeMaps(size)](templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n              flex-basis: ", "%;\n              max-width: ", "%;\n              display: block;\n            "], ["\n              flex-basis: ", "%;\n              max-width: ", "%;\n              display: block;\n            "])), 100 / columns * value, 100 / columns * value);
    if (isValueAString) return mq[sizeMaps(size)](templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n              flex-basis: ", ";\n              max-width: ", ";\n              display: block;\n            "], ["\n              flex-basis: ", ";\n              max-width: ", ";\n              display: block;\n            "])), value, value);
    if (!value && value !== undefined) return mq[sizeMaps(size)](templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n              display: none;\n            "], ["\n              display: none;\n            "])));
    return mq[sizeMaps(size)](templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n            flex-grow: 1;\n            flex-basis: 0;\n            max-width: 100%;\n            display: block;\n          "], ["\n            flex-grow: 1;\n            flex-basis: 0;\n            max-width: 100%;\n            display: block;\n          "])));
  });
};

exports.makeStyledMediaQueryOffset = function (cssProperty, args) {
  var breakpoints = args.offset || getBreakpoints(args);
  var columns = args.columns || args.theme && args.theme.grid && args.theme.grid.columns || config.columns || 12;
  var mq = mediaQuery(breakpoints);
  return Object.keys(breakpoints).map(function (size) {
    var value = args.offset && args.offset[sizeMaps(size)] || args[sizeMaps(size) + "Offset"];
    var isValueANumber = exports.isNumber(value);
    var isValueAString = exports.isString(value);
    if (!value) return null;
    if (isValueANumber) return mq[sizeMaps(size)](templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n              ", ": ", "%;\n            "], ["\n              ", ": ", "%;\n            "])), cssProperty, 100 / columns * value);
    if (isValueAString) return mq[sizeMaps(size)](templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n              ", ": ", ";\n            "], ["\n              ", ": ", ";\n            "])), cssProperty, value);
    return null;
  }).filter(Boolean);
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;